import Store from 'store/store';

const EXPLORE_FORMATS_CAT = 'explore-formats';

const fire = (action, category, label) => {
	Store.emit('CUSTOM_EVENT', { action, category, label });
};

// PLAYER EVENTS

Store.on('TRACK_ASPECT_RATIO_PLAY', () => {
	fire('play-click', EXPLORE_FORMATS_CAT, '-');
});

Store.on('TRACK_ASPECT_RATIO_PAUSE', () => {
	fire('pause-click', EXPLORE_FORMATS_CAT, '-');
});

Store.on('TRACK_ASPECT_RATIO_FULL_SCREEN', () => {
	fire('expand-click', EXPLORE_FORMATS_CAT, '-');
});

Store.on('TRACK_ASPECT_RATIO_REPLAY', () => {
	fire('replay-click', EXPLORE_FORMATS_CAT, '-');
});

Store.on('TRACK_ASPECT_RATIO_MUTE_CLICK', (bool) => {
	fire('mute-click', EXPLORE_FORMATS_CAT, bool ? 'mute' : 'unmute');
});

Store.on('TRACK_ASPECT_RATIO_FORMAT_SELECT', (activeFormat) => {
	fire('format-button-click', EXPLORE_FORMATS_CAT, activeFormat);
});

Store.on('TRACK_ASPECT_RATIO_TALENT_VIDEO_CLICK', (format) => {
	fire('talent-video-click', EXPLORE_FORMATS_CAT, format);
});

// PLF GALLERY (IMAGE TILES) EVENTS

Store.on('TRACK_TILE_CLICK', ({ name, link }) => {
	fire('tileditem-cta-click', '/film-formats', `${name} - ${link}`);
});

Store.on('TRACK_VIDEO_CLICK', (format) => {
	fire('video-click', '/film-formats-videos', format);
});

Store.on('TRACK_GET_TICKETS_BUTTON_CLICK', (format) => {
	fire('button-click', '/film-formats', format);
});
